/**
*
* MollieStatus
*
*/

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import mollieButton from './mollie.png';
import messages from './messages.js';
import MollieModal from './MollieModal.jsx';

const Img = styled.img`
  height: 26px;
  width: auto;
  border-radius: 12px;
`;

function MollieStatus(props) {
  const { accountId, mollie } = props;
  const [show, setShow] = useState(false);

  if (!mollie?.status) {
    return (
      <>
        <span className="text-danger me-3"><FormattedMessage {...messages.mollieNone} /></span>
        <Button type="button" variant="link" className="p-0" onClick={() => setShow(true)}>
          <Img src={mollieButton} alt="Connect via Mollie" />
        </Button>
        <MollieModal show={show} onHide={() => setShow(false)} accountId={accountId} />
      </>
    );
  }
  const { status } = mollie;
  const profileInfo = mollie.profileId ? (
    <span className="me-2">
      {mollie.organizationId && (
        <>
          <span className="text-nowrap">
            <span className="with-colon"><FormattedMessage {...messages.mollieOrganizationId} /></span>
            <code>{mollie.organizationId}</code>
          </span>
          <span> | </span>
        </>
      )}
      <span className="text-nowrap">
        <span className="with-colon"><FormattedMessage {...messages.mollieProfileId} /></span>
        <code>{mollie.profileId}</code>
      </span>
    </span>
  ) : null;
  switch (status) {
    case 'needs-data':
      return (
        <>
          {profileInfo}
          <span className="text-danger"><FormattedMessage {...messages.mollieNeedsData} /></span>
        </>
      );
    case 'in-review':
      return (
        <>
          {profileInfo}
          <span className="text-danger"><FormattedMessage {...messages.mollieInReview} /></span>
        </>
      );
    case 'completed':
      return (
        <>
          {profileInfo}
          <span className="text-success fw-semibold"><FormattedMessage {...messages.mollieActive} /></span>
        </>
      );
    default:
      return (
        <>
          {profileInfo}
          {`Unknown Mollie status: ${status}`}
        </>
      );
  }
}

MollieStatus.propTypes = {
  accountId: PropTypes.number,
  mollie: PropTypes.object,
};

export default MollieStatus;
